import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Numero } from 'src/app/Models/numero/numero';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { DetalleCargaLiquid } from 'src/app/Models/detcargaliq/detalle-carga-liquid';
import { Liquidacion } from 'src/app/Models/liquidacion/liquidacion';
import { Gastos } from 'src/app/Models/gastos/gastos';
import { Personal } from 'src/app/Models/personal/personal';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { ArticuloDialogComponent } from '../../articulo/articulo-dialog/articulo-dialog.component';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { Ingreso } from 'src/app/Models/ingreso/ingreso';
import { ComprasArticuloComponent } from '../../compras/compras-detcompra/compras-detcompra.component';

@Component({
  selector: 'app-add-liquidacion',
  templateUrl: './add-liquidacion.component.html',
  styleUrls: ['./add-liquidacion.component.css']
})
export class AddLiquidacionComponent implements OnInit {
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('frmnewliquid', null) btnshownewliquid: ElementRef;
  @ViewChild(ComprasArticuloComponent, null) newarticulo: ComprasArticuloComponent;
  public usuario: Usuario = new Usuario();
  public usuarioActual: any = null;
  public funcion: Function;
  public isShow: boolean = false;
  public serie_boleta: Numero = new Numero();
  public serie_factura: Numero = new Numero();
  public alertType: AlertType = new AlertType();
  public fechaHoraActual: Date;
  public liquidacion = new Liquidacion()
  public detcargas: DetalleCargaLiquid[] = []
  public gastos: Gastos[] = []
  public ingresos: Ingreso[] = []
  public ventasliquidacion: any[] = [];
  public totalProductos: number
  public listapersonal: Personal[] = [];
  public filtro: Filtro = new Filtro()
  public otrasventas: any;
  public entradas: any;
  public isedit: boolean = false;
  //variables temoprales

  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) { }

  ngOnInit() {
  }

  public show1(affterfunction: Function = null, fupdate: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;
    setTimeout(async () => {
      if (this.btnshownewliquid && this.btnshownewliquid.nativeElement) {
        this.btnshownewliquid.nativeElement.click();
      } else {
        console.error('btnshownewliquid no está disponible');
      }
      this.loading.show('Cargando datos');
      this.getPersonal();

      console.log(this.liquidacion);

      if (this.isedit) {
        this.getGastos();
        this.getVentasLiquidacion();
        //this.getSelfliquida()
        this.getDetCargas()
        this.getOtrasVentas()
        this.getIngresos()

      }
      this.loading.hide();
      console.log("mostrando series");
      console.log(this.serie_boleta);
      console.log(this.serie_factura);
    }, 10);
  }

  public show(affterfunction: Function = null, fupdate: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;

    setTimeout(async () => {
      if (this.btnshownewliquid && this.btnshownewliquid.nativeElement) {
        this.btnshownewliquid.nativeElement.click();
      } else {
        console.error('btnshownewliquid no está disponible');
      }

      this.usuarioActual = this.data.getCurrentUser();
      this.loading.show('Cargando datos');
      this.getPersonal();

      console.log("📋 Liquidación a editar:", this.liquidacion);

      if (this.isedit) {
        // ✅ IMPORTANTE: Cargar en este orden específico
        // 1. Primero cargar gastos/ingresos (para determinar si hay depósitos)
        await this.getGastosAsync();
        await this.getIngresosAsync();
        await this.getOtrasVentasAsync();

        // 2. Luego cargar ventas
        await this.getVentasLiquidacionAsync();

        // 3. FINALMENTE cargar detcargas (que usa la info de depósitos)
        await this.getDetCargas();
      }

      this.loading.hide();
    }, 10);
  }

  // ✅ Versiones async de las funciones para controlar el orden
  async getGastosAsync() {
    return new Promise<void>((resolve) => {
      this.data.GetFromId('getgastosfliq', this.liquidacion.idliquida).subscribe(
        r => {
          this.gastos = r;
          this.SumaGastos();
          resolve();
        },
        () => resolve()
      );
    });
  }

  async getIngresosAsync() {
    return new Promise<void>((resolve) => {
      this.data.GetFromId('getingresosfliq', this.liquidacion.idliquida).subscribe(
        r => {
          this.ingresos = r;
          this.SumaIngresos();
          resolve();
        },
        () => resolve()
      );
    });
  }

  async getOtrasVentasAsync() {
    return new Promise<void>((resolve) => {
      this.getOtrasVentas();
      setTimeout(() => resolve(), 500); // Esperar a que termine
    });
  }

  async getVentasLiquidacionAsync() {
    return new Promise<void>((resolve) => {
      this.getVentasLiquidacion();
      setTimeout(() => resolve(), 500);
    });
  }

  getVentasLiquidacion() {
    this.filtro.fecha = this.liquidacion.fecha

    // this.filtro.idvende = this.liquidacion.idpersonal
    this.filtro.idvende = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    this.data.Post('getventasliq', this.filtro).subscribe(r => {
      this.ventasliquidacion = r.productos;
      this.totalProductos = r.totalProductos;
      // console.log("Ventas Liquidacion: ", this.ventasliquidacion);
      // console.log("Ventas Liquidacin R: ", r.totalProductos);
      this.SumaVentas();
    })
  }

  getVentasLiquidacion1() {
    this.filtro.fecha = this.liquidacion.fecha;

    this.filtro.idvende = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    this.data.Post('getventasliq', this.filtro).subscribe(r => {
      // El backend devuelve directamente el array de productos
      this.ventasliquidacion = r || [];  // Si es null/undefined, usar array vacío

      // Calcular el total de productos sumando las cantidades
      this.totalProductos = this.ventasliquidacion.reduce((sum, item) => {
        return sum + (parseFloat(item.Cantidad) || 0);
      }, 0);

      console.log("Ventas Liquidacion: ", this.ventasliquidacion);
      console.log("Total Productos: ", this.totalProductos);

      this.SumaVentas();
    }, error => {
      // Manejar errores para evitar que la app se rompa
      console.error('Error al obtener ventas:', error);
      this.ventasliquidacion = [];
      this.totalProductos = 0;
      this.SumaVentas();
    });
  }

  guardarVentasLiquidacion() {

  }


  getOtrasVentas() {
    this.filtro.fecha = this.liquidacion.fecha;

    //this.filtro.idvende = this.liquidacion.idpersonal;
    this.filtro.idvende = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    this.data.Post('getotrasventas', this.filtro).subscribe(r => {
      console.log("Get Otras ventas", r);

      // Resetear valores
      this.liquidacion.tarjeta = 0;
      this.liquidacion.otorga_credito = 0;
      this.liquidacion.billeteraelec = 0;
      this.liquidacion.fise = 0;

      if (r.length > 0) {
        r.forEach(elem => {
          console.log("Elemento seleccionado: ", elem);

          const importe = parseFloat(elem.sum_importe) || 0;

          switch (elem.codigo) {
            case "01":
              this.liquidacion.tarjeta += importe;
              break;
            case "13":
              this.liquidacion.otorga_credito += importe;
              break;
            case "15":
              this.liquidacion.billeteraelec += importe;
              break;
            case "17":
              this.liquidacion.fise += importe;
              break;
            default:
              // Puedes manejar otros códigos aquí si es necesario
              break;
          }
        });

        // Redondear a 2 decimales
        this.liquidacion.tarjeta = parseFloat(this.liquidacion.tarjeta.toFixed(2));
        this.liquidacion.otorga_credito = parseFloat(this.liquidacion.otorga_credito.toFixed(2));
        this.liquidacion.billeteraelec = parseFloat(this.liquidacion.billeteraelec.toFixed(2));
        this.liquidacion.fise = parseFloat(this.liquidacion.fise.toFixed(2));
      }

      this.SumaVentas();
    });
  }



  close() {
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow = false; }, 500);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }

  countViajesForProduct(idproduct: number, detcargas: DetalleCargaLiquid[]): number {
    return detcargas.filter(item => item.idproduct === idproduct).length;
  }

  AddDetCargaLiq1() {

    document.getElementById('frmnewliquid').style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    this.newarticulo.articulo = new Articulo()
    this.newarticulo.show(() => {
      document.getElementById('frmnewliquid').style.overflow = 'auto';
      document.body.style.overflow = '';
      if (this.newarticulo.articulo.idproduct != undefined) {

        let detcarg = new DetalleCargaLiquid();
        detcarg.idproduct = this.newarticulo.articulo;
        detcarg.viaje = 1
        detcarg.pres_devo = 0;
        detcarg.entrada_carga = 0;
        detcarg.salida_carga = this.newarticulo.cantidad;
        this.detcargas.push(detcarg);
        console.log(this.detcargas);

      } else {
        console.log("articulo no sleccionado");
      }
    })

  }

  AddDetCargaLiq() {
    document.getElementById('frmnewliquid').style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    this.newarticulo.articulo = new Articulo()
    this.newarticulo.show(() => {
      document.getElementById('frmnewliquid').style.overflow = 'auto';
      document.body.style.overflow = '';
      if (this.newarticulo.articulo.idproduct != undefined) {
        let detcarg = new DetalleCargaLiquid();
        detcarg.idproduct = this.newarticulo.articulo;
        detcarg.viaje = 1
        detcarg.pres_devo = 0;
        detcarg.entrada_carga = 0;
        detcarg.salida_carga = this.newarticulo.cantidad;
        this.detcargas.push(detcarg);

        // ✅ Solo recalcular salidas si es edición sin depósitos
        const hayDepositos = (this.liquidacion.efectivo && this.liquidacion.efectivo > 0) ||
          (this.liquidacion.deposito && this.liquidacion.deposito > 0);

        this.SumasDetcargaliq(!hayDepositos && this.isedit);
      } else {
        console.log("articulo no seleccionado");
      }
    })
  }



  UpdateDetCargaLiq1(index: number, field: string, value: string) {
    this.detcargas[index][field] = value;
    if (field === 'entrada_carga' || field === 'salida_carga') {
      this.CalcularPresDevol(index);
      this.SumasDetcargaliq();
    }
  }

  UpdateDetCargaLiq(index: number, field: string, value: string) {
    this.detcargas[index][field] = value;

    if (field === 'entrada_carga' || field === 'salida_carga') {
      this.CalcularPresDevol(index);

      // ✅ SOLO recalcular totales si ya hay depósitos (modo cierre)
      // Si no hay depósitos, solo estamos editando salidas
      const hayDepositos = (this.liquidacion.efectivo && this.liquidacion.efectivo > 0) ||
        (this.liquidacion.deposito && this.liquidacion.deposito > 0);

      if (hayDepositos || !this.isedit) {
        // Si hay depósitos O es nueva liquidación, recalcular todo
        this.SumasDetcargaliq();
      } else {
        // Si NO hay depósitos (solo editando salidas), solo recalcular salida
        this.liquidacion.tot_salcarga = this.detcargas.reduce(
          (total, detalle) => total + parseFloat(detalle.salida_carga.toString()),
          0
        );
        // NO tocar tot_entradacarga ni totalcarga
      }
    }
  }

  getDetCargas1() {
    this.data.GetFromValue(this.data.api.detallecarga, 'idliquida', this.liquidacion.idliquida).subscribe(r => {
      this.detcargas = r;
      console.log('Mostrando detcargas', this.detcargas);
      this.GetEntradasProductos();
    })
  }

  getDetCargas() {
    console.log("🎯 getDetCargas() iniciado");
    console.log("💰 Efectivo actual:", this.liquidacion.efectivo);
    console.log("🏦 Depósito actual:", this.liquidacion.deposito);

    this.data.GetFromValue(this.data.api.detallecarga, 'idliquida', this.liquidacion.idliquida).subscribe(r => {
      this.detcargas = r;
      console.log('📦 Detcargas ORIGINALES de BD:', JSON.stringify(this.detcargas, null, 2));

      const hayDepositos = (this.liquidacion.efectivo && this.liquidacion.efectivo > 0) ||
        (this.liquidacion.deposito && this.liquidacion.deposito > 0);

      console.log("❓ ¿Hay depósitos?", hayDepositos);

      if (hayDepositos) {
        console.log("➡️ Llamando a GetEntradasProductos()");
        this.GetEntradasProductos();
      } else {
        console.log("➡️ Forzando entrada_carga = 0");
        this.detcargas.forEach(det => {
          console.log(`   Producto ${det.idproduct.nombre}: entrada_carga ${det.entrada_carga} -> 0`);
          det.entrada_carga = 0;
          det.pres_devo = 0;
        });

        this.SumasDetcargaliq(true);
        console.log("📊 Totales después de forzar entrada = 0:", {
          tot_salcarga: this.liquidacion.tot_salcarga,
          tot_entradacarga: this.liquidacion.tot_entradacarga,
          totalcarga: this.liquidacion.totalcarga
        });
      }
    });
  }

  GetEntradasProductos1() {
    this.filtro.fecha = this.liquidacion.fecha

    //this.filtro.idvende = this.liquidacion.idpersonal
    this.filtro.idvende = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    this.data.Post('get_entradas_detliq', this.filtro).subscribe(r => {
      console.log(r);
      this.entradas = r;
      this.GetEntradaPorProducto()
    },
      (error) => { console.log(error.error) })
  }

  GetEntradasProductos() {
    this.filtro.fecha = this.liquidacion.fecha;

    this.filtro.idvende = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    this.data.Post('get_entradas_detliq', this.filtro).subscribe(
      r => {
        console.log("📥 Entradas desde ventas:", r);
        this.entradas = r;
        this.GetEntradaPorProducto();
      },
      (error) => {
        console.error("❌ Error obteniendo entradas:", error);
      }
    );
  }


  GetEntradaPorProducto1() {
    let cil_vacios = 0;
    this.entradas.forEach(elem => {
      let detfinded = this.detcargas.find(det => det.idproduct.idproduct === elem.producto);
      if (detfinded) {
        console.log("producto encontrado");
        console.log(detfinded);
        detfinded.entrada_carga = detfinded.salida_carga - elem.cantidad
        // if (elem.producto !== 2 || elem.producto !== 3) {
        //   cil_vacios += elem.cantidad
        // }
        if (elem.prestamo) {
          console.log("Prestamo detectado para : ", detfinded);

          detfinded.pres_devo += elem.saldo
        }

      }
    });
    this.detcargas.forEach(num => {
      let isFound = this.entradas.some(elem => num.idproduct.idproduct === elem.producto);
      if (!isFound) {
        console.log("producto no encontrado");
        console.log(num);
        num.entrada_carga = num.salida_carga

      }
    });
    let cilindros = this.detcargas.find(det => det.idproduct.idproduct === 3);
    console.log(cilindros);
    + cil_vacios
    this.SumasDetcargaliq()
  }

  GetEntradaPorProducto() {
    let cil_vacios = 0;

    // ✅ Verificar si hay depósitos
    const hayDepositos = (this.liquidacion.efectivo && this.liquidacion.efectivo > 0) ||
      (this.liquidacion.deposito && this.liquidacion.deposito > 0);

    console.log("🔍 GetEntradaPorProducto - hayDepositos:", hayDepositos);

    if (hayDepositos) {
      // 🔒 CON DEPÓSITOS: Calcular entradas desde ventas
      console.log("🔒 Calculando entradas desde ventas");

      this.entradas.forEach(elem => {
        let detfinded = this.detcargas.find(det => det.idproduct.idproduct === elem.producto);
        if (detfinded) {
          console.log(`✅ Producto ${elem.producto} encontrado - calculando entrada`);
          detfinded.entrada_carga = detfinded.salida_carga - elem.cantidad;

          if (elem.prestamo) {
            console.log(`📦 Préstamo detectado para producto ${elem.producto}`);
            detfinded.pres_devo += elem.saldo;
          }
        }
      });

      // Productos sin ventas = se devolvieron todos
      this.detcargas.forEach(num => {
        let isFound = this.entradas.some(elem => num.idproduct.idproduct === elem.producto);
        if (!isFound) {
          console.log(`⚠️ Producto ${num.idproduct.idproduct} sin ventas - entrada = salida`);
          num.entrada_carga = num.salida_carga;
        }
      });

      // Recalcular TODO (salidas + entradas)
      this.SumasDetcargaliq(false);

    } else {
      // 🔓 SIN DEPÓSITOS: Mantener entrada = 0
      console.log("🔓 Sin depósitos - forzando entrada = 0");

      this.detcargas.forEach(det => {
        det.entrada_carga = 0;
        det.pres_devo = 0;
      });

      // Recalcular solo salidas
      this.SumasDetcargaliq(true);
    }

    console.log("📊 Detcargas después de GetEntradaPorProducto:", this.detcargas);
  }



  getPersonal() {
    this.data.GetSimple(this.data.api.personal).subscribe((r) => {
      this.listapersonal = r
    })
  }

  DeleteDetCargaLiq(index: number) {
    // this.detcargas.splice(index, 1);
    this.deleteDetCarga(index);
  }

  CalcularPresDevol(index: number) {
    const item = this.detcargas[index];
    if (item.salida_carga && item.entrada_carga)
      item.pres_devo = item.salida_carga - item.entrada_carga
    else
      item.pres_devo = 0
  }

  guardarDetalleCarga1(item: DetalleCargaLiquid) {
    item.idproduct = item.idproduct.idproduct
    this.data.Post(this.data.api.detallecarga, item).subscribe((r) => { console.log(r) }, (error) => { console.log(error) })
  }

  actualizarDetalleCarga1(item: DetalleCargaLiquid) {
    item.idproduct = item.idproduct.idproduct
    item.idliquida = item.idliquida.idliquida
    this.data.Put(this.data.api.detallecarga, item.idcargaliq.toString(), item).subscribe((r) => { console.log(r) }, (error) => { console.log(error) })
  }

  guardarDetalleCarga(item: DetalleCargaLiquid, soloSalida: boolean = false) {
    const detParaEnviar: any = {
      idliquida: item.idliquida,
      idproduct: typeof item.idproduct === 'object' ? item.idproduct.idproduct : item.idproduct,
      salida_carga: item.salida_carga,
      viaje: item.viaje || 1,
      pres_devo: item.pres_devo || 0
    };

    if (!soloSalida) {
      // Solo incluir entrada_carga si NO es solo edición de salida
      detParaEnviar.entrada_carga = item.entrada_carga || 0;
    } else {
      // Cuando es solo salida, entrada_carga debe ser 0 (aún no regresó)
      detParaEnviar.entrada_carga = 0;
    }

    console.log("💾 Guardando detalle de carga:", detParaEnviar);

    this.data.Post(this.data.api.detallecarga, detParaEnviar).subscribe(
      (r) => {
        console.log("✅ Detalle guardado:", r);
      },
      (error) => {
        console.error("❌ Error guardando detalle:", error);
      }
    );
  }

  actualizarDetalleCarga(item: DetalleCargaLiquid, soloSalida: boolean = false) {
    const detParaEnviar: any = {
      idcargaliq: item.idcargaliq,
      idliquida: typeof item.idliquida === 'object' ? item.idliquida.idliquida : item.idliquida,
      idproduct: typeof item.idproduct === 'object' ? item.idproduct.idproduct : item.idproduct,
      salida_carga: item.salida_carga,
      viaje: item.viaje || 1,
      pres_devo: item.pres_devo || 0
    };

    if (soloSalida) {
      detParaEnviar.entrada_carga = 0;
    } else {
      detParaEnviar.entrada_carga = item.entrada_carga || 0;
    }
    // Si es soloSalida, no incluimos entrada_carga en el objeto (se mantiene sin cambios en BD)

    console.log("🔄 Actualizando detalle de carga:", detParaEnviar);

    this.data.Put(this.data.api.detallecarga, item.idcargaliq.toString(), detParaEnviar).subscribe(
      (r) => {
        console.log("✅ Detalle actualizado:", r);
      },
      (error) => {
        console.error("❌ Error actualizando detalle:", error);
      }
    );
  }

  preparaData() {
    if (this.liquidacion.otorga_credito && this.liquidacion.tarjeta && this.liquidacion.billeteraelec && this.liquidacion.fise) {
      this.liquidacion.otorga_credito = parseFloat((this.liquidacion.otorga_credito).toString())
      this.liquidacion.tarjeta = parseFloat((this.liquidacion.tarjeta).toString())
      this.liquidacion.billeteraelec = parseFloat((this.liquidacion.billeteraelec).toString())
      this.liquidacion.fise = parseFloat((this.liquidacion.fise).toString())
    }
  }

  guardarLiquidacion1() {
    if (!this.liquidacion.idpersonal) {
      return this.data.notify("Seleccione un personal para la liquidacion.", "Alerta", this.data.alertType.info);
    }
    //this.liquidacion.idpersonal = this.liquidacion.idpersonal.idpersonal;

    this.getliquidacion(this.liquidacion.idpersonal);



    if (this.isedit) {
      this.preparaData();
      this.data.Put(this.data.api.liquidacion, this.liquidacion.idliquida, this.liquidacion).subscribe(r => {
        console.log(r);
        this.detcargas.forEach(det => {
          if (det.idcargaliq) {
            this.actualizarDetalleCarga(det);
          } else {
            det.idliquida = r.data.idliquida
            this.guardarDetalleCarga(det);
          }
        });
        this.data.notify(r.message, "Exito", this.data.alertType.success)
      }, (error) => { debugger; console.log(error) })
    } else {
      this.data.Post(this.data.api.liquidacion, this.liquidacion).subscribe(r => {
        console.log(r);
        this.detcargas.forEach(det => {
          det.idliquida = r.idliquida
          this.guardarDetalleCarga(det);
        });
        this.data.notify("Datos Añadidos correctamente.", "Exito", this.data.alertType.success)
      }), e => { console.log(e) }
    }
    this.close();
  }

  guardarLiquidacion2() {
    if (!this.liquidacion.idpersonal) {
      return this.data.notify("Seleccione un personal para la liquidacion.", "Alerta", this.data.alertType.info);
    }

    // ✅ Extraer ID del personal
    const idpersonal = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    // ✅ DETECTAR tipo de operación
    const hayDepositos = (this.liquidacion.efectivo && this.liquidacion.efectivo > 0) ||
      (this.liquidacion.deposito && this.liquidacion.deposito > 0);

    const soloEditandoProductos = this.isedit && !hayDepositos;

    if (this.isedit) {
      // ===== MODO EDICIÓN =====
      this.preparaData();

      // ✅ Crear copia de la liquidación para enviar
      const liquidacionParaEnviar: any = { ...this.liquidacion };
      liquidacionParaEnviar.idpersonal = idpersonal;

      if (soloEditandoProductos) {
        // 🔓 SOLO EDITANDO PRODUCTOS (Mañana)
        console.log("🔓 Editando productos de salida - Liquidación sigue ABIERTA");

        // ✅ Recalcular SOLO la salida (sin tocar entrada)
        liquidacionParaEnviar.tot_salcarga = this.detcargas.reduce(
          (total, det) => total + parseFloat(det.salida_carga.toString()),
          0
        );

        // ✅ NO recalcular tot_entradacarga, tot_presdevo, totalcarga
        // Mantener los valores que ya tenía la liquidación en la BD
        delete liquidacionParaEnviar.tot_entradacarga;
        delete liquidacionParaEnviar.tot_presdevo;
        delete liquidacionParaEnviar.totalcarga;

        // NO marcar como cerrada
        liquidacionParaEnviar.cerrada = false;
        delete liquidacionParaEnviar.fecha_cierre;

        // NO enviar campos de cierre
        delete liquidacionParaEnviar.efectivo;
        delete liquidacionParaEnviar.deposito;
        delete liquidacionParaEnviar.entrega;
        delete liquidacionParaEnviar.diferencia;
        delete liquidacionParaEnviar.neto;

      } else {
        // 🔒 CERRANDO LIQUIDACIÓN (Tarde - con depósitos)
        console.log("🔒 Cerrando liquidación con depósitos registrados");

        // ✅ Ahora SÍ recalcular todo incluyendo entradas
        this.SumasDetcargaliq();

        liquidacionParaEnviar.cerrada = true;
        liquidacionParaEnviar.fecha_cierre = new Date().toISOString();
      }

      this.data.Put(this.data.api.liquidacion, this.liquidacion.idliquida, liquidacionParaEnviar).subscribe(
        r => {
          console.log("✅ Liquidación actualizada:", r);

          // ✅ Actualizar detalles de carga
          this.detcargas.forEach(det => {
            if (det.idcargaliq) {
              this.actualizarDetalleCarga(det, soloEditandoProductos);
            } else {
              det.idliquida = r.data.idliquida;
              this.guardarDetalleCarga(det, soloEditandoProductos);
            }
          });

          const mensaje = soloEditandoProductos
            ? "Productos de salida actualizados. La liquidación sigue ABIERTA."
            : "Liquidación CERRADA exitosamente con depósitos registrados.";

          this.data.notify(mensaje, "Éxito", this.data.alertType.success);
          this.close();
        },
        (error) => {
          console.error("❌ Error al actualizar liquidación:", error);
          this.data.notify("Error al guardar la liquidación", "Error", this.data.alertType.error);
        }
      );

    } else {
      // ===== MODO CREACIÓN =====
      console.log("✨ Creando nueva liquidación (ABIERTA)");

      // ✅ Al crear, calcular solo salidas (entradas = 0)
      const tot_salcarga = this.detcargas.reduce(
        (total, det) => total + parseFloat(det.salida_carga.toString()),
        0
      );

      const nuevaLiquidacion = {
        ...this.liquidacion,
        idpersonal: idpersonal,
        cerrada: false,
        tot_salcarga: tot_salcarga,
        tot_entradacarga: 0,  // ✅ SIEMPRE 0 al crear
        tot_presdevo: 0,
        totalcarga: tot_salcarga  // salida - 0 = salida
      };

      this.data.Post(this.data.api.liquidacion, nuevaLiquidacion).subscribe(
        r => {
          console.log("✅ Nueva liquidación creada:", r);

          this.detcargas.forEach(det => {
            det.idliquida = r.idliquida;
            this.guardarDetalleCarga(det, true); // true = solo salida
          });

          this.data.notify("Liquidación creada correctamente.", "Éxito", this.data.alertType.success);
          this.close();
        },
        e => {
          console.error("❌ Error al crear liquidación:", e);
          this.data.notify("Error al crear la liquidación", "Error", this.data.alertType.error);
        }
      );
    }
  }

  async guardarLiquidacion() {
    if (!this.liquidacion.idpersonal) {
      return this.data.notify("Seleccione un personal para la liquidacion.", "Alerta", this.data.alertType.info);
    }

    const idpersonal = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    const hayDepositos = (this.liquidacion.efectivo && this.liquidacion.efectivo > 0) ||
      (this.liquidacion.deposito && this.liquidacion.deposito > 0);

    const soloEditandoProductos = this.isedit && !hayDepositos;

    if (this.isedit) {
      // ===== MODO EDICIÓN =====
      this.preparaData();

      const liquidacionParaEnviar: any = { ...this.liquidacion };
      liquidacionParaEnviar.idpersonal = idpersonal;

      if (soloEditandoProductos) {
        console.log("🔓 Editando productos de salida - Liquidación sigue ABIERTA");

        liquidacionParaEnviar.tot_salcarga = this.detcargas.reduce(
          (total, det) => total + parseFloat(det.salida_carga.toString()),
          0
        );

        delete liquidacionParaEnviar.tot_entradacarga;
        delete liquidacionParaEnviar.tot_presdevo;
        delete liquidacionParaEnviar.totalcarga;
        liquidacionParaEnviar.cerrada = false;
        delete liquidacionParaEnviar.fecha_cierre;

      } else {
        console.log("🔒 Cerrando liquidación con depósitos registrados");
        this.SumasDetcargaliq();
        liquidacionParaEnviar.cerrada = true;
        liquidacionParaEnviar.fecha_cierre = new Date().toISOString();
      }

      try {
        const r = await this.data.AsyncPut(this.data.api.liquidacion, this.liquidacion.idliquida, liquidacionParaEnviar);
        console.log("✅ Liquidación actualizada:", r);

        // ✅ CORRECCIÓN: Guardar/actualizar detalles en secuencia
        for (const det of this.detcargas) {
          if (det.idcargaliq) {
            // Detalle ya existe en BD - ACTUALIZAR
            await this.actualizarDetalleAsync(det, soloEditandoProductos);
          } else {
            // Detalle nuevo - CREAR
            det.idliquida = this.liquidacion.idliquida;
            await this.guardarDetalleAsync(det, soloEditandoProductos);
          }
        }

        const mensaje = soloEditandoProductos
          ? "Productos de salida actualizados. La liquidación sigue ABIERTA."
          : "Liquidación CERRADA exitosamente con depósitos registrados.";

        this.data.notify(mensaje, "Éxito", this.data.alertType.success);
        this.close();

      } catch (error) {
        console.error("❌ Error al actualizar liquidación:", error);
        this.data.notify("Error al guardar la liquidación", "Error", this.data.alertType.error);
      }

    } else {
      // ===== MODO CREACIÓN =====
      console.log("✨ Creando nueva liquidación (ABIERTA)");

      const tot_salcarga = this.detcargas.reduce(
        (total, det) => total + parseFloat(det.salida_carga.toString()),
        0
      );

      const nuevaLiquidacion = {
        ...this.liquidacion,
        idpersonal: idpersonal,
        cerrada: false,
        tot_salcarga: tot_salcarga,
        tot_entradacarga: 0,
        tot_presdevo: 0,
        totalcarga: tot_salcarga
      };

      try {
        const r = await this.data.AsyncPost(this.data.api.liquidacion, nuevaLiquidacion);
        console.log("✅ Nueva liquidación creada:", r);

        // ✅ CORRECCIÓN: Guardar detalles en secuencia
        for (const det of this.detcargas) {
          det.idliquida = r.idliquida;
          await this.guardarDetalleAsync(det, true);
        }

        this.data.notify("Liquidación creada correctamente.", "Éxito", this.data.alertType.success);
        this.close();

      } catch (e) {
        console.error("❌ Error al crear liquidación:", e);
        this.data.notify("Error al crear la liquidación", "Error", this.data.alertType.error);
      }
    }
  }

  // Versión async de guardarDetalleCarga
  async guardarDetalleAsync(item: DetalleCargaLiquid, soloSalida: boolean = false): Promise<any> {
    const detParaEnviar: any = {
      idliquida: typeof item.idliquida === 'object' ? item.idliquida.idliquida : item.idliquida,
      idproduct: typeof item.idproduct === 'object' ? item.idproduct.idproduct : item.idproduct,
      salida_carga: item.salida_carga,
      viaje: item.viaje || 1,
      pres_devo: item.pres_devo || 0
    };

    if (!soloSalida) {
      detParaEnviar.entrada_carga = item.entrada_carga || 0;
    } else {
      detParaEnviar.entrada_carga = 0;
    }

    console.log("💾 Guardando detalle de carga:", detParaEnviar);

    return this.data.AsyncPost(this.data.api.detallecarga, detParaEnviar);
  }

  // Versión async de actualizarDetalleCarga
  async actualizarDetalleAsync(item: DetalleCargaLiquid, soloSalida: boolean = false): Promise<any> {
    const detParaEnviar: any = {
      idcargaliq: item.idcargaliq,
      idliquida: typeof item.idliquida === 'object' ? item.idliquida.idliquida : item.idliquida,
      idproduct: typeof item.idproduct === 'object' ? item.idproduct.idproduct : item.idproduct,
      salida_carga: item.salida_carga,
      viaje: item.viaje || 1,
      pres_devo: item.pres_devo || 0
    };

    if (soloSalida) {
      // Si es solo salida, forzar entrada_carga = 0 (aún no regresó)
      detParaEnviar.entrada_carga = 0;
    } else {
      // Si NO es solo salida, usar el valor actual
      detParaEnviar.entrada_carga = item.entrada_carga || 0;
    }

    console.log("🔄 Actualizando detalle de carga:", detParaEnviar);

    return this.data.AsyncPut(this.data.api.detallecarga, item.idcargaliq.toString(), detParaEnviar);
  }



  SumasDetcargaliq1() {
    this.liquidacion.tot_salcarga = this.detcargas.reduce((total, detalle) => total + parseFloat(detalle.salida_carga.toString()), 0);
    this.liquidacion.tot_entradacarga = this.detcargas.reduce((total, detalle) => total + parseFloat(detalle.entrada_carga.toString()), 0);
    this.liquidacion.tot_presdevo = this.detcargas.reduce((total, detalle) => total + parseFloat(detalle.pres_devo.toString()), 0);
    console.log(this.liquidacion);
    this.liquidacion.totalcarga = this.liquidacion.tot_salcarga - this.liquidacion.tot_entradacarga //- this.liquidacion.tot_presdevo

  }

  SumasDetcargaliq(soloSalidas: boolean = false) {
    // SIEMPRE calcular salida
    this.liquidacion.tot_salcarga = this.detcargas.reduce(
      (total, detalle) => total + parseFloat(detalle.salida_carga.toString()),
      0
    );

    if (!soloSalidas) {
      // Solo si NO es "solo salidas", calcular entradas y préstamos
      this.liquidacion.tot_entradacarga = this.detcargas.reduce(
        (total, detalle) => total + parseFloat(detalle.entrada_carga.toString()),
        0
      );

      this.liquidacion.tot_presdevo = this.detcargas.reduce(
        (total, detalle) => total + parseFloat(detalle.pres_devo.toString()),
        0
      );

      this.liquidacion.totalcarga = this.liquidacion.tot_salcarga - this.liquidacion.tot_entradacarga;
    } else {
      // Si es solo salidas, calcular totalcarga asumiendo entrada = 0
      this.liquidacion.totalcarga = this.liquidacion.tot_salcarga;
    }

    console.log("📊 Totales calculados:", {
      tot_salcarga: this.liquidacion.tot_salcarga,
      tot_entradacarga: this.liquidacion.tot_entradacarga,
      totalcarga: this.liquidacion.totalcarga,
      soloSalidas
    });
  }

  SumaCantidadVentas() {
    this.liquidacion.cant_venta = 0
    console.log("cantidad de ventas", this.liquidacion.cant_venta);
    this.ventasliquidacion.forEach(venta => {
      console.log("venta", venta.Descripcion);
      if (venta.Descripcion != "TAPERS") {
        this.liquidacion.cant_venta += (parseFloat(venta.Cantidad))
      }
    });
    console.log("cantidad de ventas", this.liquidacion.cant_venta);
  }

  SumaTotalCarga() {
    this.liquidacion.totalcarga = this.liquidacion.tot_salcarga - this.liquidacion.tot_entradacarga + this.liquidacion.tot_presdevo
  }

  SumaVentas() {
    if (this.ventasliquidacion.length <= 0) {
      this.liquidacion.tot_venta = 0
    } else {
      this.liquidacion.tot_venta = this.ventasliquidacion.reduce((total, detalle) => total + parseFloat(detalle.Total.toString()), 0);
      this.SumaCantidadVentas()
      this.SumaNeto()
    }
  }

  SumaGastos() {
    if (this.gastos.length <= 0) {
      this.liquidacion.gasto = 0
    } else {
      this.liquidacion.gasto = this.gastos.reduce((total, detalle) => total + parseFloat(detalle.total.toString()), 0);
      this.SumaNeto()
    }
  }

  SumaIngresos() {
    if (this.ingresos.length <= 0) {
      this.liquidacion.cobro_credito = 0
    } else {
      this.liquidacion.cobro_credito = this.ingresos.reduce((total, detalle) => total + parseFloat(detalle.total.toString()), 0);
      this.SumaNeto()
    }
  }



  SumaNeto() {
    const totVenta = this.data.toNumber(this.liquidacion.tot_venta);
    const cobro_credito = this.data.toNumber(this.liquidacion.cobro_credito);
    const gasto = this.data.toNumber(this.liquidacion.gasto);
    const billeteraelec = this.data.toNumber(this.liquidacion.billeteraelec);
    const fise = this.data.toNumber(this.liquidacion.fise);
    const otorga_credito = this.data.toNumber(this.liquidacion.otorga_credito);
    const tarjeta = this.data.toNumber(this.liquidacion.tarjeta);

    // leer efectivo y deposito, convertir seguro
    const efectivo = this.data.toNumber(this.liquidacion.efectivo);
    const deposito = this.data.toNumber(this.liquidacion.deposito);

    // asignar entrega = suma de los 2 (redondeo a 2 decimales)
    const entrega = Math.round((efectivo + deposito) * 100) / 100;
    this.liquidacion.entrega = entrega;

    // calcular neto y diferencia (también redondeados)
    const neto = totVenta + cobro_credito - gasto - billeteraelec - fise - otorga_credito - tarjeta;
    this.liquidacion.neto = Math.round(neto * 100) / 100;

    const diferencia = Math.round((this.liquidacion.neto - this.liquidacion.entrega) * 100) / 100;
    this.liquidacion.diferencia = diferencia;
  }

  onEfectivoChange(value: string) {
    this.liquidacion.efectivo = parseFloat(value) || 0;
    this.updateEntrega();
    this.SumaNeto();
  }

  onDepositoChange(value: string) {
    this.liquidacion.deposito = parseFloat(value) || 0;
    this.updateEntrega();
    this.SumaNeto();
  }

  updateEntrega() {
    this.liquidacion.entrega = (this.liquidacion.efectivo || 0) + (this.liquidacion.deposito || 0);
  }


  //isedit
  getGastos() {
    console.log(this.liquidacion.idliquida)
    this.data.GetFromId('getgastosfliq', this.liquidacion.idliquida).subscribe(r => {
      this.gastos = r;
      this.SumaGastos()
    })
  }

  getIngresos() {
    console.log(this.liquidacion.idliquida)
    this.data.GetFromId('getingresosfliq', this.liquidacion.idliquida).subscribe(r => {
      this.ingresos = r;
      this.SumaIngresos();
    })
  }

  getSelfliquida() {
    this.data.GetFromId(this.data.api.liquidacion, this.liquidacion.idliquida).subscribe(r => {
      this.liquidacion = r;
    })
  }

  deleteDetCarga1(index: number) {
    let detcarg = this.detcargas[index];
    if (detcarg.idcargaliq) {
      this.data.Delete(this.data.api.detallecarga, detcarg.idcargaliq.toString()).subscribe(r => {
        console.log(r);
        this.detcargas.splice(index, 1);
        this.SumasDetcargaliq();
      })
    } else {
      this.detcargas.splice(index, 1);
      this.SumasDetcargaliq();
    }
  }

  deleteDetCarga(index: number) {
    let detcarg = this.detcargas[index];
    if (detcarg.idcargaliq) {
      this.data.Delete(this.data.api.detallecarga, detcarg.idcargaliq.toString()).subscribe(r => {
        console.log(r);
        this.detcargas.splice(index, 1);

        // ✅ Solo recalcular salidas si es edición sin depósitos
        const hayDepositos = (this.liquidacion.efectivo && this.liquidacion.efectivo > 0) ||
          (this.liquidacion.deposito && this.liquidacion.deposito > 0);

        this.SumasDetcargaliq(!hayDepositos && this.isedit);
      })
    } else {
      this.detcargas.splice(index, 1);

      const hayDepositos = (this.liquidacion.efectivo && this.liquidacion.efectivo > 0) ||
        (this.liquidacion.deposito && this.liquidacion.deposito > 0);

      this.SumasDetcargaliq(!hayDepositos && this.isedit);
    }
  }

  deleteGasto(index: number) {
    const gasto = this.gastos[index];
    if (gasto.idgasto) {
      this.data.Delete(this.data.api.gasto, gasto.idgasto.toString()).subscribe(() => {
        this.gastos.splice(index, 1);
        this.SumaGastos();
      }, (error) => {
        console.error('Error al eliminar gasto:', error);
        this.data.notify('No se pudo eliminar el gasto', 'Error', this.data.alertType.error);
      });
    } else {
      this.gastos.splice(index, 1);
      this.SumaGastos();
    }
  }

  getliquidacion(idpersonal) {
    console.log("idPersonal deubbbbb:", idpersonal);

    const datapersonal = { 'fecha': this.liquidacion.fecha, 'idpersonal': idpersonal }
    console.log(datapersonal);

    this.data.Post('getLiqGasto', datapersonal).subscribe((data) => {
      // Manejar la respuesta exitosa


      console.log('Liquidación obtenida:', data);
      this.data.notify("Ya se creo una liquidacion con este personal.", "Alerta", this.data.alertType.info)
      this.liquidacion.idpersonal = null;
      return;
    },
      (error) => {
        // Manejar el error de obtener la liquidación
        console.error('Error al obtener la liquidación:', error);
        if (error.status === 500) {

          this.data.notify("Ya se creo una liquidacion con esta fecha.", "Alerta", this.data.alertType.info)
          this.liquidacion.idpersonal = null;
          return;
        }

      }
    );

  }

}
